<div *ngIf="planModel">
    <h3>
        Subscription Plan: <i>{{ planModel.label }}</i> Tiers
    </h3>

    <div class="create">
        <button
            [disabled]="planModel.subscriber_count > 0"
            class="btn btn-sm btn-primary"
            [routerLink]="[
                '/',
                'subscriptions-plans',
                planModel.id,
                'tiers',
                0
            ]"
        >
            <i class="bi bi-plus"></i>
        </button>
    </div>

    <table mat-table [dataSource]="tierModels" class="table-list">
        <ng-container matColumnDef="control">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let tierModel">
                <div class="btn-group">
                    <button
                        [routerLink]="[
                            '/subscriptions-plans',
                            planModel.id,
                            'tiers',
                            tierModel.id
                        ]"
                        class="btn btn-sm btn-success"
                    >
                        <i class="bi bi-pencil"></i>
                    </button>

                    <button
                        [disabled]="planModel.subscriber_count > 0"
                        class="btn btn-sm btn-danger"
                        (click)="confirmDelete(tierModel)"
                    >
                        <i class="bi bi-trash2"></i>
                    </button>
                </div>
            </td>
        </ng-container>

        <ng-container matColumnDef="id">
            <th mat-header-cell *matHeaderCellDef>ID</th>
            <td mat-cell *matCellDef="let tierModel">
                {{ tierModel.id }}
            </td>
        </ng-container>

        <ng-container matColumnDef="sequence_number">
            <th mat-header-cell *matHeaderCellDef>Seq No</th>
            <td mat-cell *matCellDef="let tierModel">
                {{ tierModel.sequence_number }}
            </td>
        </ng-container>

        <ng-container matColumnDef="label">
            <th mat-header-cell *matHeaderCellDef>Label</th>
            <td mat-cell *matCellDef="let tierModel">
                {{ tierModel.label }}
            </td>
        </ng-container>

        <ng-container matColumnDef="description">
            <th mat-header-cell *matHeaderCellDef>Description</th>
            <td mat-cell *matCellDef="let tierModel">
                {{ tierModel.description }}
            </td>
        </ng-container>

        <ng-container matColumnDef="amount">
            <th mat-header-cell *matHeaderCellDef>Amount</th>
            <td mat-cell *matCellDef="let tierModel">
                {{ tierModel.amount | currency }}
            </td>
        </ng-container>

        <ng-container matColumnDef="period_unit">
            <th mat-header-cell *matHeaderCellDef>Period Unit</th>
            <td mat-cell *matCellDef="let tierModel">
                {{ tierModel.period_unit | humancase }}
            </td>
        </ng-container>

        <ng-container matColumnDef="period_count">
            <th mat-header-cell *matHeaderCellDef>Period Count</th>
            <td mat-cell *matCellDef="let tierModel">
                {{ tierModel.period_count }}
            </td>
        </ng-container>

        <ng-container matColumnDef="cycles">
            <th mat-header-cell *matHeaderCellDef>Cycles</th>
            <td mat-cell *matCellDef="let tierModel">
                {{ tierModel.cycles }}
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="columnHeadings"></tr>
        <tr mat-row *matRowDef="let row; columns: columnHeadings"></tr>
    </table>
</div>
